import { combineReducers } from 'redux'

import auth from './auth'
import sites from './sites'
import typeReducer from './types'
import content from './content'
import users from './users'
import ui from './ui'

export default combineReducers({
  auth,
  sites,
  types: typeReducer('type'),
  roles: typeReducer('role'),
  content,
  users,
  ui
})



// WEBPACK FOOTER //
// ./app/reducers/index.js